(function () {
  if (!window.fwGiftRules || !Array.isArray(window.fwGiftRules) || window.fwGiftRules.length === 0) return;

  var STATE_KEY_PREFIX = "fw_gift_state_";
  var modifying = false;
  var pendingEval = false;

  function getState(ruleKey) {
    try {
      var raw = sessionStorage.getItem(STATE_KEY_PREFIX + ruleKey);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function setState(ruleKey, state) {
    try {
      sessionStorage.setItem(STATE_KEY_PREFIX + ruleKey, JSON.stringify(state));
    } catch (e) {}
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + "cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function findGiftLine(cart, rule) {
    return (cart.items || []).find(function (item) {
      return (
        item.variant_id === rule.giftVariantId &&
        item.properties &&
        String(item.properties._auto_gift) === "true"
      );
    });
  }

  function countTriggerItems(cart, rule) {
    var ids = rule.triggerProductIds || [];
    if (ids.length === 0) return 0;
    var idSet = new Set(ids);
    return (cart.items || []).reduce(function (sum, item) {
      // Gratis-Zeilen nicht als Trigger mitzählen (wichtig bei "gleiches Produkt gratis")
      if (item.properties && String(item.properties._auto_gift) === "true") return sum;
      return idSet.has(item.product_id) ? sum + item.quantity : sum;
    }, 0);
  }

  function addGift(rule) {
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: rule.giftVariantId,
            quantity: rule.giftQuantity,
            properties: { _auto_gift: "true" }
          }
        ]
      })
    });
  }

  function removeLine(lineKey) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
  }

  function notifyCartChanged() {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }

  async function applyRule(rule, cart) {
    var state = getState(rule.key);
    var triggerCount = countTriggerItems(cart, rule);
    var giftLine = findGiftLine(cart, rule);
    var meets = triggerCount >= rule.threshold;

    if (!meets) {
      if (giftLine) {
        await removeLine(giftLine.key);
        setState(rule.key, {});
        return true;
      }
      if (state.addedAt || state.dismissed) setState(rule.key, {});
      return false;
    }

    if (giftLine) return false;

    if (state.addedAt && !state.dismissed) {
      setState(rule.key, { addedAt: state.addedAt, dismissed: true });
      return false;
    }

    if (state.dismissed) return false;

    await addGift(rule);
    setState(rule.key, { addedAt: Date.now(), dismissed: false });
    return true;
  }

  async function evaluate() {
    if (modifying) {
      pendingEval = true;
      return;
    }
    modifying = true;
    try {
      var cart = await fetchCart();
      var changed = false;
      for (var i = 0; i < window.fwGiftRules.length; i++) {
        var didChange = await applyRule(window.fwGiftRules[i], cart);
        if (didChange) changed = true;
      }
      if (changed) notifyCartChanged();
    } catch (e) {
      console.warn("[fw-gift-engine]", e);
    } finally {
      modifying = false;
      if (pendingEval) {
        pendingEval = false;
        evaluate();
      }
    }
  }

  var debounceTimer = null;
  function scheduleEvaluate() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(evaluate, 200);
  }

  document.addEventListener("cart:change", scheduleEvaluate);
  document.addEventListener("cart:refresh", scheduleEvaluate);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", evaluate);
  } else {
    evaluate();
  }
})();
